import { render, staticRenderFns } from "./ActionCollaborative.vue?vue&type=template&id=8de87144&"
import script from "./ActionCollaborative.vue?vue&type=script&lang=js&"
export * from "./ActionCollaborative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports